/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormQuestionFromJSON, FormQuestionToJSON, } from './FormQuestion';
/**
 * Check if a given object implements the FormStep interface.
 */
export function instanceOfFormStep(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('questions' in value) || value['questions'] === undefined)
        return false;
    return true;
}
export function FormStepFromJSON(json) {
    return FormStepFromJSONTyped(json, false);
}
export function FormStepFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'questions': (json['questions'].map(FormQuestionFromJSON)),
    };
}
export function FormStepToJSON(json) {
    return FormStepToJSONTyped(json, false);
}
export function FormStepToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'questions': (value['questions'].map(FormQuestionToJSON)),
    };
}
